export enum AuthorizationMode {
  Claims = 'Claims', // Claims mode requires that you setup appRoles as specified in documentation.
  SharePoint = 'SharePoint' // SharePoint mode was default for Workplace and requires that atleast 2 SharePoint groups are setup on the coreWorkplaceSiteUrl.
}
